import { render, staticRenderFns } from "./Donate.vue?vue&type=template&id=d336bef8&scoped=true&"
import script from "./Donate.vue?vue&type=script&lang=js&"
export * from "./Donate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d336bef8",
  null
  
)

export default component.exports